import React from 'react';
import Button, {LinkButton, RouterLinkButton} from '../../../components/button/button';
import {FormattedMessage} from 'react-intl';
import searchFilter from '../../../searchFilter';
import {useLocation} from 'react-router-dom';
import {TELEGRAM_SUPPORT} from '../../../constants';
import MessageQuestionSquareIcon from '../../../assets/icons0/message-question-square.svg';
import CreditCard02Icon from '../../../assets/icons0/credit-card-02.svg';
import ShoppingBag03Icon from '../../../assets/icons0/shopping-bag-03.svg';
import ArrowBlockDownIcon from '../../../assets/icons0/arrow-block-down.svg';
import CalendarIcon from '../../../assets/icons0/calendar.svg';
import Feedback from '../../../components/feedback/feedback';

export const TicketingCompleteActionSuccess = React.memo(({downloadSuccessfullImpulseFiles, showWalletButtonSuccess}) => {
    const location = useLocation();
  
    return (
        <div className='checkout-complete__actions display-flex flex-direction-column mw768-justify-content-center row-gap-0dot75rem'>
            {showWalletButtonSuccess &&
                <RouterLinkButton {...{color: 'primary-gradient', size: 'lg', fluid: 'always', to: `/wallet${searchFilter(location.search)}`}} >
                    <ShoppingBag03Icon className='display-block width-1dot25rem height-1dot25rem margin-right-0dot5rem'/>
                    <FormattedMessage defaultMessage='To wallet'/>
                </RouterLinkButton>
            }
            <div className='display-flex flex-direction-column-row row-gap-0dot75rem column-gap-0dot75rem justify-content-center'>
                <Button {...{color: 'primary-inverse', size: 'lg', fluid: 'always', clickHandler: downloadSuccessfullImpulseFiles}} >
                    <ArrowBlockDownIcon className='display-block width-1dot25rem height-1dot25rem margin-right-0dot5rem'/>
                    <FormattedMessage defaultMessage='Download ticket'/>
                </Button>
                {/* <Button {...{color: 'primary-inverse', size: 'lg', fluid: 'always'}}>
                    <CalendarIcon className='display-block width-1dot25rem height-1dot25rem margin-right-0dot5rem'/>
                    <FormattedMessage defaultMessage='Add to calendar'/>
                </Button> */}
            </div>
            <RouterLinkButton {...{color: 'secondary-gray', size: 'lg', fluid: 'always', to: `/${searchFilter(location.search)}`}} >
                <FormattedMessage defaultMessage='Return to main page'/>
            </RouterLinkButton>
            <RouterLinkButton {...{color: 'secondary-gray', size: 'lg', fluid: 'always', to: `/vibe/profiles/ottry${searchFilter(location.search)}`}} >
                Що нового на платформі?
            </RouterLinkButton>
        </div>
    )
});

export const TicketingCompleteActionError = React.memo(({serviceLink}) => {
    const location = useLocation();
    
    return (
        <div className='checkout-complete__actions checkout-complete__actions--error display-flex flex-direction-column mw768-justify-content-center row-gap-0dot75rem'>
            <div className='display-flex flex-direction-column-row row-gap-0dot75rem column-gap-0dot75rem justify-content-center'>
                {/* <RouterLinkButton {...{color: 'primary-inverse', size: 'lg', fluid: 'always', to: `/wallet${searchFilter(location.search)}`}} >
                    <CreditCard02Icon className='display-block width-1dot25rem height-1dot25rem margin-right-0dot5rem'/>
                    <FormattedMessage defaultMessage='Choose another payment method'/>
                </RouterLinkButton> */}
                <LinkButton {...{color: 'primary-inverse', size: 'lg', fluid: 'always', link: {href: TELEGRAM_SUPPORT, target: 'blank'}}}>
                    <MessageQuestionSquareIcon className='display-block width-1dot25rem height-1dot25rem margin-right-0dot5rem'/>
                    <FormattedMessage defaultMessage='Contact support'/>
                </LinkButton>
            </div>
            <RouterLinkButton {...{color: 'secondary-gray', size: 'lg', fluid: 'always', to: `${serviceLink}${searchFilter(location.search)}`}} >
                <FormattedMessage defaultMessage='Return to event'/>
            </RouterLinkButton>
        </div>
    )
});
